import paginatedSchools from './Schools.paginated'
import { LicenseManagementSchoolIdServices } from './[id]'

export const LicenseManagementSchoolsServices = {
  id: LicenseManagementSchoolIdServices,
  ...paginatedSchools
}
export * from './Schools.types'
export * from './[id]'
